export default function lsServiceNameFilter(value) {
    const serviceNames = {
        'Lawn Mowing': 'Mowing',
    };

    return serviceNames[value] || value;
}
